/**
 *  @class
 *  @function CollectionListSort
 *
 *  Client-side sorting for the collection list toolbar. The cards carry
 *  data-cl-position (curated block order = bestseller ranking) and
 *  data-cl-date (collection publish date), so no request is needed —
 *  the grid children are simply re-appended in the chosen order.
 */
if (!customElements.get('collection-list-sort')) {
  class CollectionListSort extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[name="collection_list_sort"]');
      const section = this.closest('.list-collections');
      this.grid = section ? section.querySelector('.collection-grid') : null;
      if (!this.input || !this.grid) {
        return;
      }
      this.input.addEventListener('change', () => {
        this.applySort(this.input.value);
      });
    }

    applySort(mode) {
      const position = (el) => parseInt(el.getAttribute('data-cl-position'), 10) || 0;
      const published = (el) => parseInt(el.getAttribute('data-cl-date'), 10) || 0;

      const cards = Array.from(this.grid.children);
      cards.sort((a, b) => {
        if (mode === 'new') {
          return (published(b) - published(a)) || (position(a) - position(b));
        }
        return position(a) - position(b);
      });
      cards.forEach((card) => this.grid.appendChild(card));

      this.querySelectorAll('.custom-select--list button').forEach((button) => {
        const active = button.dataset.value === mode;
        button.classList.toggle('custom-select--item-active', active);
        if (active) {
          button.setAttribute('aria-current', 'true');
        } else {
          button.removeAttribute('aria-current');
        }
      });
    }
  }
  customElements.define('collection-list-sort', CollectionListSort);
}
